var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner check-expression" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          staticStyle: { height: "100%" },
          attrs: { "body-style": { padding: "0px" } }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("SystemMaintenance.ValidationExpression")))
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isEditCheckRule,
                    expression: "isEditCheckRule"
                  }
                ]
              },
              [
                _vm.currOptStatus === _vm.optStatusDef.normal
                  ? [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.showAdd }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Create")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.showEdit }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Edit")))]
                      ),
                      _c(
                        "el-button",
                        { attrs: { type: "danger" }, on: { click: _vm.del } },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Delete")))]
                      )
                    ]
                  : [
                      _c(
                        "el-button",
                        { attrs: { type: "primary" }, on: { click: _vm.save } },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Save")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.cancel }
                        },
                        [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
                      )
                    ]
              ],
              2
            )
          ]),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              style: {
                position: "relative",
                "min-height": "300px",
                height: _vm.isEdit ? "auto" : "100%"
              }
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isEdit,
                    expression: "isEdit"
                  }
                ],
                staticClass: "pure-loading-mask"
              }),
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isEditCheckRule && _vm.currOptStatus,
                  expression: "isEditCheckRule && currOptStatus"
                }
              ],
              staticClass: "app-main-inner-row"
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { width: "100%" },
                  attrs: { "label-position": "left", "label-width": "90px" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Relation") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: !_vm.isEdit },
                          model: {
                            value: _vm.oneCheckExpression.relation,
                            callback: function($$v) {
                              _vm.$set(_vm.oneCheckExpression, "relation", $$v)
                            },
                            expression: "oneCheckExpression.relation"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v(_vm._s(_vm.$t("SystemMaintenance.And")))
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("SystemMaintenance.Or")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SystemMaintenance.ValidationItem")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          attrs: { disabled: !_vm.isEdit, filterable: "" },
                          on: { change: _vm.onCheckItemChange },
                          model: {
                            value: _vm.oneCheckExpression.checkItem,
                            callback: function($$v) {
                              _vm.$set(_vm.oneCheckExpression, "checkItem", $$v)
                            },
                            expression: "oneCheckExpression.checkItem"
                          }
                        },
                        _vm._l(_vm.checkItems, function(item, index) {
                          return _c("el-option", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.filterCheckItems(
                                  _vm.checkRule.checkNode,
                                  item.code
                                ),
                                expression:
                                  "filterCheckItems(checkRule.checkNode, item.code)"
                              }
                            ],
                            key: index,
                            attrs: { label: item.chineseName, value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Operation") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "300px" },
                          attrs: {
                            disabled:
                              !_vm.isEdit ||
                              _vm.oneCheckExpression.checkItem ===
                                "MBL_CANNOT_REPEATED" ||
                              _vm.oneCheckExpression.checkItem ===
                                _vm.LOGIC_MANIFEST_EQUAL_CONTAINER_NUM.code ||
                              _vm.oneCheckExpression.checkItem ===
                                _vm.LOGIC_QUANTITY_WEIGHT_VOLUME_CONSISTENT.code
                          },
                          on: {
                            change: function(p) {
                              _vm.operateChangeHandle(p)
                            }
                          },
                          model: {
                            value: _vm.oneCheckExpression.operator,
                            callback: function($$v) {
                              _vm.$set(_vm.oneCheckExpression, "operator", $$v)
                            },
                            expression: "oneCheckExpression.operator"
                          }
                        },
                        [
                          _vm._l(_vm.operators, function(item, index) {
                            return _c("el-option", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.filterOperators(
                                    _vm.oneCheckExpression.checkItem,
                                    item.code
                                  ),
                                  expression:
                                    "filterOperators(oneCheckExpression.checkItem, item.code)"
                                }
                              ],
                              key: index,
                              attrs: {
                                label: item.chineseName,
                                value: item.code
                              }
                            })
                          }),
                          _vm.showLikeOperator
                            ? _c("el-option", {
                                key: "like",
                                attrs: {
                                  label: _vm.LIKE_OPERATOR.chineseName,
                                  value: _vm.LIKE_OPERATOR.code
                                }
                              })
                            : _vm._e(),
                          _vm.showNotLikeOperator
                            ? _c("el-option", {
                                key: "notLike",
                                attrs: {
                                  label: _vm.NOT_LIKE_OPERATOR.chineseName,
                                  value: _vm.NOT_LIKE_OPERATOR.code
                                }
                              })
                            : _vm._e(),
                          _vm.oneCheckExpression.checkItem ===
                            _vm.LOGIC_DYNAMIC_FILE_TYPE.code ||
                          _vm.oneCheckExpression.checkItem ===
                            _vm.IS_ATTACHMENT_MISSING.code ||
                          _vm.oneCheckExpression.checkItem ===
                            _vm.LOGIC_AP_CHARGE_ACCOUNT_ID_NOT_UNIQUE.code
                            ? _c("el-option", {
                                key: "satisfyOne",
                                attrs: {
                                  label: _vm.SATISFY_ONE.chineseName,
                                  value: _vm.SATISFY_ONE.code
                                }
                              })
                            : _vm._e(),
                          _vm.showNotEmptyOperator
                            ? _c("el-option", {
                                key: "notEmpty",
                                attrs: {
                                  label: _vm.NOT_EMPTY.chineseName,
                                  value: _vm.NOT_EMPTY.code
                                }
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm.oneCheckExpression.operator === _vm.NOT_EMPTY.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: { label: " ", disabled: true },
                            model: {
                              value: _vm.oneCheckExpression.checkValue,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.oneCheckExpression,
                                  "checkValue",
                                  $$v
                                )
                              },
                              expression: "oneCheckExpression.checkValue"
                            }
                          })
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem === "TRUST_JOB_STATE" ||
                      _vm.oneCheckExpression.checkItem === "RELATED_JOB_STATE"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit },
                              model: {
                                value: _vm.oneCheckExpression.checkValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneCheckExpression,
                                    "checkValue",
                                    $$v
                                  )
                                },
                                expression: "oneCheckExpression.checkValue"
                              }
                            },
                            _vm._l(_vm.jobStatus, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem === "LOCAL_SERVICES"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Message.FilterValue") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit },
                              model: {
                                value: _vm.oneCheckExpression.checkValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneCheckExpression,
                                    "checkValue",
                                    $$v
                                  )
                                },
                                expression: "oneCheckExpression.checkValue"
                              }
                            },
                            _vm._l(_vm.LOCAL_SERVICES_TYPE, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem === "FILE_UPLOADED"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit },
                              model: {
                                value: _vm.fileTypeEditor.lob,
                                callback: function($$v) {
                                  _vm.$set(_vm.fileTypeEditor, "lob", $$v)
                                },
                                expression: "fileTypeEditor.lob"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_OceanExport"),
                                  value: "SE"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_OceanImport"),
                                  value: "SI"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_AirExport"),
                                  value: "AE"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_AirImport"),
                                  value: "AI"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_RailwayBusiness"
                                  ),
                                  value: "RE"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_IntegratedJob"),
                                  value: "IE"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: {
                              width: "300px",
                              "margin-left": "10px"
                            },
                            attrs: {
                              value: _vm.convertFileCategoryLabel(
                                _vm.oneCheckExpression.checkValue
                              ),
                              disabled: !_vm.isEdit,
                              placeholder: _vm.$t(
                                "SystemMaintenance.SelectFileType"
                              )
                            },
                            on: { focus: _vm.onSelectFileType }
                          })
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                        _vm.LOGIC_DYNAMIC_FILE_TYPE.code &&
                      _vm.oneCheckExpression.operator === _vm.SATISFY_ONE.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit },
                              model: {
                                value: _vm.fileTypeEditor.lob,
                                callback: function($$v) {
                                  _vm.$set(_vm.fileTypeEditor, "lob", $$v)
                                },
                                expression: "fileTypeEditor.lob"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_OceanExport"),
                                  value: "SE"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_OceanImport"),
                                  value: "SI"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_AirExport"),
                                  value: "AE"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_AirImport"),
                                  value: "AI"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_RailwayExport"),
                                  value: "RE"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_RailwayImport"),
                                  value: "RI"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_Parter"),
                                  value: "PT"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_FbaSea"),
                                  value: "FBA_SE"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_FbaAir"),
                                  value: "FBA_AE"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_FbaRailway"),
                                  value: "FBA_RE"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_IntegratedJob"),
                                  value: "IE"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: {
                              width: "300px",
                              "margin-left": "10px"
                            },
                            attrs: {
                              value: _vm.oneCheckExpression.checkValue,
                              disabled: !_vm.isEdit,
                              placeholder: _vm.$t(
                                "SystemMaintenance.SelectFileType"
                              )
                            },
                            on: { focus: _vm.onSelectFileType }
                          })
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                        _vm.IS_ATTACHMENT_MISSING.code &&
                      _vm.oneCheckExpression.operator ===
                        _vm.CheckRuleConstants.EQUAL.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit },
                              model: {
                                value: _vm.fileTypeEditor.lob,
                                callback: function($$v) {
                                  _vm.$set(_vm.fileTypeEditor, "lob", $$v)
                                },
                                expression: "fileTypeEditor.lob"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_Parter"),
                                  value: "PT"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-input", {
                            staticStyle: {
                              width: "300px",
                              "margin-left": "10px"
                            },
                            attrs: {
                              value: _vm.oneCheckExpression.checkValue,
                              disabled: !_vm.isEdit,
                              placeholder: _vm.$t(
                                "SystemMaintenance.SelectFileType"
                              )
                            },
                            on: { focus: _vm.onSelectFileType }
                          })
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                        "SLAVE_FILE_VERIFY" ||
                      _vm.oneCheckExpression.checkItem ===
                        _vm.LOGIC_MANIFEST_EQUAL_CONTAINER_NUM.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.oneCheckExpression.checkValue,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.oneCheckExpression,
                                  "checkValue",
                                  $$v
                                )
                              },
                              expression: "oneCheckExpression.checkValue"
                            }
                          })
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                      _vm.LOGIC_SENSITIVE_WORD_ENGLISH_NAME.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit, filterable: "" },
                              model: {
                                value: _vm.oneCheckExpression.checkValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneCheckExpression,
                                    "checkValue",
                                    $$v
                                  )
                                },
                                expression: "oneCheckExpression.checkValue"
                              }
                            },
                            _vm._l(_vm.sensitiveWordEnglishSet, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { value: item }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                      _vm.LOGIC_APPLICATION_STATUS_FOR_RELEASE.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit, filterable: "" },
                              model: {
                                value: _vm.oneCheckExpression.checkValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneCheckExpression,
                                    "checkValue",
                                    $$v
                                  )
                                },
                                expression: "oneCheckExpression.checkValue"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("SeaExport.NotApplying"),
                                  value: "0"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("SeaExport.Requested"),
                                  value: "1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                      _vm.LOGIC_SENSITIVE_WORD_CHINESE_NAME.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit, filterable: "" },
                              model: {
                                value: _vm.oneCheckExpression.checkValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneCheckExpression,
                                    "checkValue",
                                    $$v
                                  )
                                },
                                expression: "oneCheckExpression.checkValue"
                              }
                            },
                            _vm._l(_vm.sensitiveWordChinesSet, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { value: item }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                      _vm.LOGIC_SENSITIVE_WORD_MARK.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit, filterable: "" },
                              model: {
                                value: _vm.oneCheckExpression.checkValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneCheckExpression,
                                    "checkValue",
                                    $$v
                                  )
                                },
                                expression: "oneCheckExpression.checkValue"
                              }
                            },
                            _vm._l(_vm.sensitiveWordMarkSet, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { value: item }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : [
                        _vm.LOGIC_SENSITIVE_WORD_COMMUNICATION_FIRST_LINE.code,
                        _vm.LOGIC_SENSITIVE_WORD_HBL_COMMUNICATION_FIRST_LINE
                          .code,
                        _vm.LOGIC_SENSITIVE_WORD_JOB_COMMUNICATION_FIRST_LINE
                          .code
                      ].includes(_vm.oneCheckExpression.checkItem)
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit, filterable: "" },
                              model: {
                                value: _vm.oneCheckExpression.checkValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneCheckExpression,
                                    "checkValue",
                                    $$v
                                  )
                                },
                                expression: "oneCheckExpression.checkValue"
                              }
                            },
                            _vm._l(_vm.sensitiveWordCommunicationSet, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: { value: item }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                      _vm.LOGIC_AP_CHARGE_ACCOUNT_ID_NOT_UNIQUE.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            key: "chargeItem-multiple",
                            staticStyle: { width: "300px" },
                            attrs: {
                              no: "chargeItem-multiple",
                              "options-width": "250px",
                              filterable: "",
                              clearable: true,
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              "default-multiple-value":
                                _vm.toArray(
                                  _vm.oneCheckExpression.checkValue
                                ) instanceof Array
                                  ? _vm.toArray(
                                      _vm.oneCheckExpression.checkValue
                                    )
                                  : [],
                              "tag-value": "itemId",
                              "tag-name": "enName",
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                return (_vm.oneCheckExpression.checkValue =
                                  p.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                      _vm.REQUIRE_USER_DEFINED_ROLE_ID1.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              disabled: !_vm.isEdit,
                              "select-type":
                                _vm.selectTypeNames.basic_data_User,
                              url: _vm.URL.sys.getUsersByPrivilegeDetail,
                              cache: false,
                              "method-params": {
                                category: "role",
                                shape: "userDefinedRole1",
                                active: true
                              },
                              filterable: "",
                              "default-multiple-value": _vm.toNumArray(
                                _vm.oneCheckExpression.checkValue
                              ),
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.oneCheckExpression.checkValue = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                      _vm.REQUIRE_USER_DEFINED_ROLE_ID2.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              disabled: !_vm.isEdit,
                              "select-type":
                                _vm.selectTypeNames.basic_data_User,
                              url: _vm.URL.sys.getUsersByPrivilegeDetail,
                              cache: false,
                              "method-params": {
                                category: "role",
                                shape: "userDefinedRole2",
                                active: true
                              },
                              filterable: "",
                              "default-multiple-value": _vm.toNumArray(
                                _vm.oneCheckExpression.checkValue
                              ),
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.oneCheckExpression.checkValue = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                        _vm.LOGIC_CONSIGNATION_COMPANY_SCOPE.code ||
                      _vm.oneCheckExpression.checkItem ===
                        _vm.LOGIC_RECEIVABLE_ACCOUNT_OBJECT_SCOPE.code ||
                      _vm.oneCheckExpression.checkItem ===
                        _vm.CLIENT_SCOPE_HAVE_CHARGE.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              disabled: !_vm.isEdit,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params":
                                _vm.oneCheckExpression.checkItem ===
                                _vm.LOGIC_CONSIGNATION_COMPANY_SCOPE.code
                                  ? { customer: true, active: true }
                                  : { active: true },
                              filterable: "",
                              "default-multiple-value": _vm.toNumArray(
                                _vm.oneCheckExpression.checkValue
                              ),
                              multiple: true
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.oneCheckExpression.checkValue = _vm.toTxt(
                                  p.value
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                      _vm.BILLING_CHARGE_CONFIRM_STATE_CHECK.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit, filterable: "" },
                              model: {
                                value: _vm.oneCheckExpression.checkValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneCheckExpression,
                                    "checkValue",
                                    $$v
                                  )
                                },
                                expression: "oneCheckExpression.checkValue"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("SeaExport.yes"),
                                  value: "yes"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                      _vm.LOGIC_INVOICE_TAX_NATURE_SAME.code
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit, filterable: "" },
                              model: {
                                value: _vm.oneCheckExpression.checkValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneCheckExpression,
                                    "checkValue",
                                    $$v
                                  )
                                },
                                expression: "oneCheckExpression.checkValue"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("SeaExport.yes"),
                                  value: "1"
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("SeaExport.no"),
                                  value: "0"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm.oneCheckExpression.checkItem ===
                      _vm.LOGIC_INVOICE_NATURE.code
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Message.FilterValue") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { disabled: !_vm.isEdit },
                              model: {
                                value: _vm.oneCheckExpression.checkValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.oneCheckExpression,
                                    "checkValue",
                                    $$v
                                  )
                                },
                                expression: "oneCheckExpression.checkValue"
                              }
                            },
                            _vm._l(_vm.INVOICE_NATURES, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.FilterValue")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              disabled:
                                !_vm.isEdit ||
                                _vm.oneCheckExpression.checkItem ===
                                  "MBL_CANNOT_REPEATED" ||
                                _vm.oneCheckExpression.checkItem ===
                                  _vm.LOGIC_QUANTITY_WEIGHT_VOLUME_CONSISTENT
                                    .code
                            },
                            model: {
                              value: _vm.oneCheckExpression.checkValue,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.oneCheckExpression,
                                  "checkValue",
                                  $$v
                                )
                              },
                              expression: "oneCheckExpression.checkValue"
                            }
                          })
                        ],
                        1
                      ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SystemMaintenance.CustomDescription")
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { disabled: !_vm.isEdit },
                        model: {
                          value: _vm.oneCheckExpression.customDescription,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.oneCheckExpression,
                              "customDescription",
                              $$v
                            )
                          },
                          expression: "oneCheckExpression.customDescription"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { disabled: !_vm.isEdit },
                        model: {
                          value: _vm.oneCheckExpression.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.oneCheckExpression, "remark", $$v)
                          },
                          expression: "oneCheckExpression.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.fileTypeEditor.visible
        ? _c("mx-file-type-editor", {
            attrs: {
              visible: _vm.fileTypeEditor.visible,
              lob: _vm.fileTypeEditorLob,
              "file-id": _vm.fileTypeEditor.fileId,
              "file-category": _vm.fileTypeEditor.fileCategory
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.fileTypeEditor, "visible", $event)
              },
              saveFileType: _vm.onSaveFileType
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }